import React from 'react'
import styles from './styles.module.scss'

const PayWallPhone = () => (
    <div className={styles.wrap}>
        <span>
        свяжитесь с менеджером в Telegram{' '}
            {/* Временно скрыто: поддержка в МАКС
                <a href="https://max.ru/u/f9LHodD0cOIAVt7Zg_ukFhe6Qw_5sgNWro0T4-_WyxIKxbVugh-hydSRlno" target="_blank" rel="noopener noreferrer">
                    МАКС +79365150373
                </a> или Telegram{' '}
            */}
            <a href="https://t.me/partsautoexpert_bot" target="_blank" rel="noopener noreferrer">
                @partsautoexpert_bot
            </a>
        </span>
    </div>

)

export default  PayWallPhone
